import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaTiktok } from 'react-icons/fa';
import logo from '../assets/logo.png';

const Footer = () => {
    return (
        <footer className="footer-section pt-5 pb-3">
            <div className="footer-bg-overlay"></div>
            <div className="container footer-content">
                <div className="row">
                    {/* Left Column */}
                    <div className="col-lg-5 mb-5 mb-lg-0">
                        <img src={logo} alt="Zubis Nursery" className="footer-logo img-fluid" />
                        <p className="footer-quote mt-3">
                            We Blend The Warmth of Home With The Wonder of Learning.
                        </p>
                    </div>

                    {/* Right Column */}
                    <div className="col-lg-7">
                        {/* Navigation Links */}
                        <div className="mb-5">
                            <Link to="/" className="footer-nav-link">Home</Link>
                            <Link to="/about" className="footer-nav-link">About Us</Link>
                            <Link to="/curriculum" className="footer-nav-link">Curriculum</Link>
                            <Link to="/healthy-eating" className="footer-nav-link">Healthy Eating</Link>
                            <Link to="/admission" className="footer-nav-link">Admission & Fee</Link>
                        </div>

                        {/* Get In Touch */}
                        <div className="mb-5">
                            <h3 className="footer-heading mt-0">Get In Touch</h3>
                            <div className="footer-contact-info">
                                <p>2 Queen Anne's Place, Bush Hill Park, Enfield, EN1 2PX</p>
                                <p>020 3770 9599</p>
                                <p><a href="mailto:info@zubisnursery.com">info@zubisnursery.com</a></p>
                            </div>
                        </div>

                        {/* Join Us On */}
                        <div>
                            <h3 className="footer-heading">Join Us On</h3>
                            <div className="social-icons-footer">
                                <a target='_blank' href="https://www.instagram.com/zubis_nursery" ><FaInstagram /></a>
                                <a target='_blank' href="https://www.facebook.com/share/17dZDEp8up/?mibextid=wwXIfr" ><FaFacebookF /></a>
                                <a target='_blank' href="https://www.tiktok.com/@zubisnursery?lang=en"><FaTiktok /></a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <p className="mb-2 mb-md-0">&copy; {new Date().getFullYear()} - Zubis Nursery, All rights are reserved.</p>
                    <a href="#">Privacy Policy</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
